import { useEffect, useState } from "react";
import Layout from "../../components/layoutMasterConfig/layoutMaster";
import { setupAPIclient } from "../../services/setupAPIclientAuth";
import { toast } from "react-toastify";
import { Zip_Code_Api } from "../../services/zip_code_api/zip_code_api";
import DataTable, { TableColumn } from "react-data-table-component";
import { apiClientMater } from "../../services/setupClientMaster/apiClientMaster";
import edit from '../../components/dashboard/img/favicon/editar.png';




type DataRow = {
    id: number;
    name: string;
};


function ConfigMasterCancelamento(){


    // const [showDivregistered, showDivRegistered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showFormUpdate, setShowFormUpdate] = useState(false);
    const [formData, setFormData] = useState<{    
        name: string;
    }>({
        name: ""
    });
    
    
  
    // Função para manipular a mudança nos inputs
    function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>){
        const { name, value } = e.target;  
        setFormData({
          ...formData,  
          [name]: value, 
        });
    };
  
      const resetForm = (enableModal:boolean) => {
        setFormData({
          name: ''
        });

        if(enableModal){
            setShowModal(true)
        }

      };
      
    async function handleSubmit(e: React.FormEvent<HTMLFormElement>){
        e.preventDefault();
        if(formData.name === ""){
          return  toast.warning("O campo nome não pode estar vazio!")
        }else{
          const loadingToast = toast.info("Processando... aguarde", {
            autoClose: false,
        });
        toast.dismiss(loadingToast);
        try {
            const ApiClient = apiClientMater();
            const response = await ApiClient.post("/crud/create/ReasonCancellation", {
                name: formData.name
            });
            if (response.status >= 200 && response.status < 300) {
                toast.success("Cadastrado com sucesso! 🎉");
                resetForm(false);
               // showDivRegistered(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);

            } else {
                throw new Error(`Erro inesperado: ${response.status}`);
            }
        } catch (error) {
            const errorMessage =  "Erro ao registrar o motivo de cancelamento. Tente novamente.";
            toast.error(errorMessage);
        }
        }
    };

    const [filterText, setFilterText] = useState(""); 
    const [Iduser, setShowIduser] = useState(0);
    const [getData, setgetData] = useState<DataRow[]>([]);


      const columns: TableColumn<DataRow>[] = [
        {
            name: "Nome",
            selector: (row) => row.name, 
            sortable: true,
        },
        {
          name: 'Ações',
          cell: (row: { id: number }) => (
            <button className=' btn'  onClick={() => handleButtonUpdate(row.id)}>

              <img src={edit} width={20} alt="Editar" />

            </button>
          ),
          ignoreRowClick: true, 
          allowOverflow: true,
          button: true
        },
      ];
 

      const handleButtonUpdate = (id: number) => {
        const selectedItem = getData.find((item) => item.id === id);
        setShowIduser(id)
        setFormData({
            name: selectedItem?.name ?? ""
        });
        setShowFormUpdate(true)
      }
      const filteredData = getData.filter(
        (item) =>
          item.name?.toLowerCase().includes(filterText.toLowerCase()) 
      );
      const handleSubmitUpdate = async () => {

        // alert(Iduser)
  
        if(formData.name === ""){
          return  toast.warning("O campo nome não pode estar vazio!")
        }else{

          const loadingToast = toast.info("Processando... aguarde", {
            autoClose: false,
          });
          toast.dismiss(loadingToast);


          try {
            const ApiClient = apiClientMater();

            const response = await ApiClient.post(`/crud/update/ReasonCancellation/${Iduser}`, {
                id: Iduser,
                name: formData.name
            });

            // Verifica se a resposta da API indica sucesso
            if (response.status >= 200 && response.status < 300) {
                toast.success("Atualizado com sucesso!");
        
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            } else {
                throw new Error(`Erro inesperado: ${response.status}`);
            }
        } catch (error) {
            console.error("Erro ao atualizar:", error);
        
            // Remove o toast de loading (caso esteja sendo usado)
            toast.dismiss(loadingToast);
        
            // Exibe uma mensagem de erro apropriada
            toast.error("Erro ao atualizar. Tente novamente.");
        }
        }
  
      
    }


    useEffect(() => {
        const handlegetActivisionData = async () => {
          const ApiClient = apiClientMater();
          const response = await ApiClient.post("/crud/ReasonCancellation");
    
            console.log(response.data)

            const formattedData = response.data.map((item: any) => ({
                id: item.id,
                name: item.name ?? "",
            }));

    
          setgetData(formattedData)
        }
        handlegetActivisionData();
    }, []);

    return(
        <Layout>
          <div>
         {!showFormUpdate ? (
         <div>

            <div className=' mr-3 mt-3 mb-3'>
                <button className='btn btn-success' onClick={() => resetForm(true) }>
                    Cadastrar motivos de cancelamento
                </button>
            </div>

            <input
              type="text"
              placeholder="Filtrar por nome do motivo"
              value={filterText}
              onChange={(e) => setFilterText(e.target.value)}
              style={{
                marginBottom: "10px",
                padding: "8px",
                width: "18%",
                border: "1px solid #ccc",
                borderRadius: "5px",
              }}
            />
            <DataTable  
              columns={columns}
              data={filteredData}
              pagination
              onSelectedRowsChange={(selected) =>
                console.log("Selected Rows: ", selected.selectedRows)
              }
            />

         </div>
        ) :  <div className='card mt-3'>
             <div className="modal-body ">
                    <form  method="POST">
                        <div className="form-group col-md-6 mt-2">
                        <input
                            type="text"
                            className="fadeIn second form-control"
                            name="name"
                            id="name"
                            placeholder="Nome"
                            value={formData.name}
                            onChange={handleChange}
                            required
                        />
                        </div>
                    </form>

                    <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={() => setShowFormUpdate(false)}>Fechar</button>
                        <button className="btn btn-success" onClick={handleSubmitUpdate}>Editar</button>
                    </div>

             </div>
           </div>}
          </div>
          {/* Modal do Bootstrap */}
          {(showModal && !showFormUpdate) && (
            <div className="modal fade show d-block">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Cadastrar motivos de cancelamento</h5>
                            <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                        </div>
                        <div className="modal-body">
                            <form  method="POST">
                                <div className="form-group col-md-6 mt-2">
                                <input
                                    type="text"
                                    className="fadeIn second form-control"
                                    name="name"
                                    id="name"
                                    placeholder="Nome"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                />
                                </div>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Fechar</button>
                            <button className="btn btn-success" onClick={handleSubmit}>Salvar</button>

                        </div>
                    </div>
                </div>
            </div>
          )}
          {/* Background escuro (overlay) */}
          {(showModal && !showFormUpdate) && <div className="modal-backdrop fade show"></div>}
        </Layout>
    )
}


export default ConfigMasterCancelamento